module.exports = __webpack_public_path__ + "img/compatible-with-mausritter-88x32-light.ebc7e058.png";